module.exports = __webpack_public_path__ + "assets/img/fusionGateway-module4-4.c66a67f3.jpg";